<div *ngIf="chartType === 'bar'">
  <canvas baseChart [chartType]="chartType" [legend]="chartLegend" width="200" height="115" [datasets]="chartData"
    [labels]="chartLabels" (chartClick)="chartClicked($event, chartIndex)" 
    [colors]="chartFor === 'hazard' ? barHRChartColors
      : chartFor === 'due' ? barDueChartColors
      : chartFor === 'risk' ? barRiskChartColors
      : chartData.length === 1 ? barChartColors : barChart2Colors" [options]="barChartOptions"
    [plugins]="barChartPlugins">
  </canvas>
</div>

<div *ngIf="chartType === 'pie'">
  <canvas baseChart [chartType]="chartType" [legend]="chartLegend" width="100" height="80" [data]="piechartData"
    [labels]="chartLabels" (chartClick)="chartClicked($event, chartIndex)"
    [colors]=" piechartData.length === 3 ? pieChart3Colors : pieChart2Colors " [options]="pieChartOptions"
    [plugins]="pieChartPlugins">
  </canvas>
</div>